export default __webpack_public_path__ + "static/media/image-chair-algo-d-2-w@3x.1aeeb67e.png";